import React, { useEffect, useState } from 'react'
import { Image } from 'antd-mobile'
import { ArrowRightIcon, ArrowRightIcon2 } from './svg'
import styles from './index.scss'
import goTo from '@/libs/functions/goTo'
import { TrackView } from '@dragonpass/intl-unified-tracker'

interface ActivityZoneListProps {
  trackData?: Record<string, any>
  trackClk?: boolean
  trackExp?: boolean
  className?: string
  style?: React.CSSProperties
  rowKey?: string
  title?: string
  desc?: string
  dataSource?: Record<string, any>[]
  fieldNames?: {
    imageUrl?: string
    title?: string
    redirectUrl?: string
  }
  squareness?: boolean
  titleClassName?: string
  descClassName?: string
}

const Index: React.FC<ActivityZoneListProps> = ({
  className,
  style,
  title,
  desc,
  rowKey = 'id',
  dataSource = [],
  fieldNames = {
    imageUrl: 'activityImage',
    title: 'activityName',
    redirectUrl: 'activityRedirectUrl',
  },
  squareness = false,
  titleClassName = '',
  descClassName = '',
  trackClk = false,
  trackExp = false,
  trackData = {},
}) => {
  const [verticalData, setVerticalData] = useState<Record<string, any>[]>([])
  const [horizontalData, setHorizontalData] = useState<Record<string, any>[]>(
    [],
  )

  useEffect(() => {
    if (dataSource.length >= 7) {
      setVerticalData(dataSource.slice(0, 4))
      setHorizontalData(dataSource.slice(4, dataSource.length))
    } else {
      setVerticalData(dataSource)
    }
  }, [dataSource.map((item) => item[rowKey]).toString()])

  return (
    <div
      className={`${styles['activity-zone-list']} ${className || ''}`}
      style={style}
    >
      {title && (
        <div
          className={`${styles['activity-zone-list-title']} ${titleClassName}`}
        >
          {title}
          {!!desc && (
            <span
              className={`${styles['activity-zone-list-desc']} ${descClassName}`}
            >
              {desc}
            </span>
          )}
        </div>
      )}
      <div className={styles['vertical-container']}>
        {verticalData.map((item, index) => (
          <TrackView
            className={styles['vertical-item']}
            key={item[rowKey] || index}
            trackData={{
              advert_name: item[fieldNames.title || ''],
              ...trackData,
            }}
            onClick={() => {
              if (fieldNames?.redirectUrl && item?.[fieldNames?.redirectUrl]) {
                goTo(item[fieldNames?.redirectUrl])
              }
            }}
            trackClk={trackClk}
            trackExp={trackExp}
          >
            <img
              key={index}
              className={styles.image}
              // fit="cover"
              src={item?.[fieldNames?.imageUrl]}
            />
            <div className={styles['title-wrap']}>
              <div className={styles.title}>{item[fieldNames.title]}</div>
              <span
                className={styles.icon}
                dangerouslySetInnerHTML={{
                  __html: squareness ? ArrowRightIcon2 : ArrowRightIcon,
                }}
              ></span>
            </div>
          </TrackView>
        ))}
      </div>
      {!!horizontalData.length && (
        <div className={styles['horizontal-container']}>
          {horizontalData.map((item, index) => (
            <div
              key={item[rowKey] || index}
              className={styles['horizontal-item']}
              onClick={() => {
                if (fieldNames?.redirectUrl && item?.[fieldNames?.redirectUrl]) {
                  goTo(item[fieldNames?.redirectUrl])
                }
              }}
            >
              <img
                className={styles.image}
                src={item?.[fieldNames?.imageUrl]}
              />
              <div className={styles['title-wrap']}>
                <div className={styles.title}>{item[fieldNames.title]}</div>
                <span
                  className={styles.icon}
                  dangerouslySetInnerHTML={{
                    __html: squareness ? ArrowRightIcon2 : ArrowRightIcon,
                  }}
                ></span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default Index
